import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import Events from '../../common/events';
import Analytics from 'APP_ROOT/services/analytics';
import Permissions from '../../../data/permissions';
import { DispatchHelpers as tagsActions, Selectors as tagsSelectors } from '../../../data/tags';
import ProfilePage from './subPages/profilePage';
import RavensPage from './subPages/ravensPage';
import TagsPage from './subPages/tagsPage';
import UsersPage from './subPages/usersPage';
import BeaconsPage from './subPages/beaconsPage';
import ProtectedRoute from '../../common/protectedRoute';

class AccountPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            usersError: null,
        }
    }

    componentDidMount() {
        Analytics.pageView();
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (!this._settingTagsInheritedUsers && // this is to prevent a second call to setTagsInheritedUsers while the first one is still in progress
            this.props.users && this.props.tags && 
            !this.props.tagsInheritedUsersAreSet) {
                
            this._settingTagsInheritedUsers = true;
            this.props.setTagsInhertiedUsers(this.props.users);
        }
    }

    loadData = () => {
        if (!this.props.ravens) this.props.getUserData(this.loadUsers);
        else this.loadUsers();
    }

    loadUsers = () => {
        if(!this.props.hasAccessToUsers){
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            console.log("User is not owner or admin, not loading users.");
            return;
        }

        if (!this.props.users){
            this.props.getUsers()
            .catch((ex) => {
                this.setState({ usersError: ex });
            })
        }
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    render() {
        if (!this.props.ravens) return null;

        if(!this.props.user) return null;

        return (
            <Switch>
                <Route path="/:lang/account/profile" render={() => <ProfilePage {...this.props} />} />
                
                <ProtectedRoute
                    path="/:lang/account/ravens"
                    component={RavensPage}
                    resource="ravens"
                    action="read"
                    passThrough={{ ...this.props, ...this.state }}
                />

                <ProtectedRoute
                    path="/:lang/account/users"
                    component={UsersPage}
                    resource="users"
                    action="read"
                    passThrough={{ ...this.props, ...this.state }}
                />

                <ProtectedRoute
                    path="/:lang/account/tags"
                    component={TagsPage}
                    resource="tags"
                    action="read"
                    passThrough={{ ...this.props, ...this.state }}
                />

                <ProtectedRoute
                    path="/:lang/account/beacons"
                    component={BeaconsPage}
                    resource="assets"
                    action="read"
                    gate={this.props.features?.has_beacons} // account has any beacons or not
                />

                {/* default to profile page */}
                <Redirect to={`/${this.props.match.params.lang}/account/profile`} />
            </Switch>
        );    
    }
}

const mapStateToProps = state => {
    return {
        tags: tagsSelectors.tags(state),        
        tagsLoaded: tagsSelectors.loaded(state),
        tagsLoading: tagsSelectors.loading(state),
        tagsError: tagsSelectors.error(state),
        tagsPending: tagsSelectors.pending(state),
        tagsInheritedUsersAreSet: tagsSelectors.inheritedUsersAreSet(state),
        hasAccessToUsers: Permissions.selectors.can(state, 'users', 'read'),
        canEditBilling: Permissions.selectors.can(state, 'billing', 'write'),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setTagsInhertiedUsers: (users) => dispatch(tagsActions.setInheritedUsers(users)),
    }
}


export { AccountPage as UnconnectedAccountPage }; // Added for testing
export default connect(mapStateToProps, mapDispatchToProps)(AccountPage);